export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                  ZAID ENTERPRISE
                </h3>
                <p className="text-sm text-gray-400">Industrial Power Solutions</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Leading provider of industrial diesel generator solutions. Reliable power for your operations with expert maintenance and trusted services.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="https://wa.me/919327380066"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Generator Repair
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Maintenance Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Generator Sales
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Generator Purchase
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Technical Support
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Emergency Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Products</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  New Generators
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Used Generators
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Generator Parts
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Control Panels
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Accessories
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Financing Options
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-accent mt-1"></i>
                <div>
                  <p className="text-gray-400">201, Karishma Complex</p>
                  <p className="text-gray-400">Opposite Muslim Hall, Navsari, Gujarat - 396445</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-accent"></i>
                <p className="text-gray-400">+91 9327380066</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-accent"></i>
                <p className="text-gray-400">zaidenterprise0066@gmail.com</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-accent"></i>
                <div>
                  <p className="text-gray-400">Available: 7 Days a Week</p>
                  <p className="text-gray-400">Emergency: 24/7</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              ZAID ENTERPRISE
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted partner for industrial diesel generator solutions. Quality service, reliable power, expert support.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://wa.me/919327380066"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#products" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Products
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Generator Repair
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Maintenance
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Sales &amp; Purchase
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Technical Support
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-accent mt-1"></i>
                <span className="text-gray-400">
                  201, Karishma Complex, Opposite Muslim Hall, Navsari, Gujarat - 396445
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-accent"></i>
                <a
                  href="tel:+919327380066"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  +91 9327380066
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-accent"></i>
                <a
                  href="mailto:zaidenterprise0066@gmail.com"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  zaidenterprise0066@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2024 ZAID ENTERPRISE. All rights reserved.</p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a
                href="#"
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?origin=logo"
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}